import 'bootstrap/js/src/tooltip'

const tooltip = {
  init: () => {
    $('body')
      .on('click', '.hc-tooltip-holder', e => {
        e.preventDefault()
      })
      .tooltip({
        selector: '.hc-tooltip-holder',
        template:
          '<div class="tooltip hc-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        html: true,
        placement: (tooltip, elem) => {
          const placementAttr = elem.getAttribute('data-placement')
          return placementAttr || 'top'
        }
      })
  },
  initCustomTooltip: ({
    $holder,
    content,
    trigger = 'hover focus',
    customClass = ''
  }) => {
    if ($holder.length > 0 && content) {
      $holder.tooltip('dispose').tooltip({
        title: content,
        template: `<div class="tooltip ${customClass}" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`,
        trigger,
        html: true
      })
    }
  }
}

export default tooltip
